import { createSlice } from "@reduxjs/toolkit";

const initialUserAuthorizationState = {
  actionLoading: false,
  userGroupAuthorities: [],
  moduleAndAuthorities: [],
  users: [],
  entity: {}
};

export const userAuthorizationSlice = createSlice({
  name: "userAuthorization",
  initialState: initialUserAuthorizationState,
  reducers: {
    startCall: (state) => {
      state.actionLoading = true;
    },
    // getList
    listFetched: (state, action) => {
      state.actionLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.entity =  action.payload.entity;
    },
    // getUsers
    usersFetched: (state, action) => {
      state.actionLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.users =  action.payload.entities;
    },
    //getAuthorities
    authoritiesFetched: (state, action) => {
      state.actionLoading = false;
      state.isSuperAdmin = action.payload.isSuperAdmin;
      state.userGroupAuthorities = action.payload.userGroupAuthorities;
      state.moduleAndAuthorities = action.payload.moduleAndAuthorities;
    },
    //saveAuthorities
    authoritiesSaved: (state) => {
      state.actionLoading = false;
    },
    // cleanAuthorities
    authoritiesCleaned: (state) => {
      state.userGroupAuthorities = [];
      state.moduleAndAuthorities = [];
    },
    // cleanAll
    allCleaned: (state) => {
      state.users = [];
      state.isSuperAdmin = false;
      state.userGroupAuthorities = [];
      state.moduleAndAuthorities = [];
    }
  }
});